import React, { useState, useEffect } from "react";
import Admin from "./Admin";
import "../../styles/admin.css";

export default function AdminUsers({ addToast }) {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);
  const [showModal, setShowModal] = useState(false);

  // Szükséges adatok
  const [isAdmin, setIsAdmin] = useState(null);


  const handleSave = () => {

    // Csak a módosított mezőket küldjük el
    const updatedData = {};
    if (isAdmin !== selectedUser.is_admin) updatedData.is_admin = isAdmin;

    if (Object.keys(updatedData).length === 0) {
      addToast("Nem történt módositás!", "warning")
      return;
    }

    fetch(`https://focifanatik.hu/api/admin_update_users.php?id=${selectedUser.id}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatedData),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          addToast("Sikeres mentés!", "success")
          handleCloseModal();

          fetch("https://focifanatik.hu/api/admin_users.php")
            .then((r) => r.json())
            .then((d) => setUsers(d));
        } else {
          addToast("Hiba!", "warning")
        }
      })
      .catch((err) => console.error("Hálózati hiba:", err));

  };


  useEffect(() => {
    // FONTOS: pontos URL
    fetch("https://focifanatik.hu/api/admin_users.php")
      .then((response) => response.json())
      .then((data) => {
        console.log("Kapott adatok:", data); // ← ezzel látod a böngésző konzolban, hogy tényleg jön adat
        setUsers(data);
      })
      .catch((err) => console.error("Hiba a lekéréskor:", err));
  }, []);


  // Modal ablakok megnyitása/bezárása
  const handleOpenModal = (user) => {
    setSelectedUser(user);
    setIsAdmin(user.is_admin);

    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false)
    setSelectedUser(null);
  };

  return (
    <div className="admin-page">
      <Admin />
      <main className="admin-content">
        <header className="admin-header">
          <h3>🏆 Felhasználók kezelése</h3>
        </header>

        <section className="admin-main">
          <p className="text-muted">Itt tudod kezelni a felhasználókat.</p>

          <div className="table-responsive mt-4">
            <table className="table table-striped text-center align-middle">
              <thead className="table-success">
                <tr>
                  <th>ID</th>
                  <th>Név</th>
                  <th>Email</th>
                  <th>Password</th>
                  <th>Total Votes</th>
                  <th>Utolsó login</th>
                  <th>Last Activity</th>
                  <th>Készitve</th>
                  <th>Admin</th>
                  <th>Email értesitesek</th>
                  <th>Utolsó email küldve</th>
                  <th>Műveletek</th>
                </tr>
              </thead>
              <tbody>
                {users.map((l) =>
                  <tr key={l.id}>
                    <td>{l.id}</td>
                    <td>{l.username}</td>
                    <td>{l.email}</td>
                    <td>*</td>
                    <td>{l.total_votes}</td>
                    <td>{l.last_login}</td>
                    <td>{l.last_activity_at}</td>
                    <td>{l.created_at}</td>
                    <td>{l.is_admin}</td>
                    <td>{l.email_notifications ? "Bekapcsolva" : "Kikapcsolva"}</td>
                    <td>{l.last_email_sent}</td>
                    <td>
                      <div className="d-flex justify-content-center gap-2">
                        <button className="btn btn-sm btn-warning" onClick={() => handleOpenModal(l)}>
                          <i className="bi bi-pencil-square"></i> Szerkesztés
                        </button>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      </main>
      {showModal && (
        <div className="modal fade show d-block mt-5" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content shadow-lg">
              <div className="modal-header custom-modal-header">
                <h5 className="modal-title">Felhasználó szerkesztése</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseModal}
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label className="form-label">Felhasználó jogosultsága</label>
                    <select
                      className="form-select"
                      value={isAdmin}
                      onChange={(e) => setIsAdmin(e.target.value)}
                    >
                      <option value="0">👤 Nem admin</option>
                      <option value="1">🛡️ Admin</option>
                    </select>
                  </div>
                </form>
              </div>


              <div className="modal-footer custom-modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCloseModal}>
                  Mégse
                </button>
                <button type="button" className="btn btn-success" onClick={handleSave}>
                  Mentés
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
